import React from "react";

const TableLoader = ({ isLoading }) => {
    return (
        <>
            <div className={`small-loader ${isLoading ? "show" : ""}`}>
                <div className="m-auto">
                    <div className="spinner">
                        <div className="sk-folding-cube">
                            <div className="sk-cube1 sk-cube"></div>
                            <div className="sk-cube2 sk-cube"></div>
                            <div className="sk-cube4 sk-cube"></div>
                            <div className="sk-cube3 sk-cube"></div>
                        </div>
                    </div>
                    <span className="text-white"> Loading...</span>
                </div>
                {/* <div className="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div> */}
            </div>
        </>
    );
};

export default TableLoader;
